import React, { useCallback, useEffect, useState } from 'react';

import DCCheckedBox from '../../Assets/icons/DCCheckedBox';
import DCEmptyBox from '../../Assets/icons/DCEmptyBox';
import { Span } from '../index';
import PropTypes from 'prop-types';
import './style.scss';

const Checkbox = ({
    unCheckIcon,
    unCheckColor,
    checkIcon,
    checkColor,
    classes,
    label,
    value,
    onChange,
    checked,
    disabled,
    id,
    inputRef,
    fullWidth,
    name,
    dataFieldId,
    style,
    checkboxStyle,
    icon,
    iconPlacement = 'end',
}) => {
    const [checkedState, setCheckedState] = useState(false);

    const defaultOnChange = useCallback(
        e => {
            // setCheckedState(e.target.checked); // This creates problem in state management
            onChange && onChange(e);
        },
        [onChange],
    );

    useEffect(() => {
        setCheckedState(checked || false);
    }, [checked]);

    return (
        <label
            className={
                'Checkbox ' +
                (classes?.main ? classes.main : '') +
                (disabled ? ' CheckboxDisabled' : '') +
                (fullWidth === true ? ' fullWidth' : '')
            }
            style={style}
            onChange={defaultOnChange}
        >
            <input
                type="checkbox"
                className="CheckboxInput"
                value={value}
                checked={checkedState}
                disabled={disabled}
                id={id}
                ref={inputRef}
                name={name}
                data-field-id={dataFieldId}
                style={checkboxStyle}
            />
            <Span
                className={`CheckboxIcon ${classes?.iconClass ? classes.iconClass : ''}`}
                style={{
                    color: checkedState === false ? unCheckColor : checkColor,
                }}
            >
                {unCheckIcon && checkedState === false ? (
                    unCheckIcon
                ) : checkedState === false ? (
                    <DCEmptyBox />
                ) : (
                    ''
                )}
                {checkIcon && checkedState === true ? (
                    checkIcon
                ) : checkedState === true ? (
                    <DCCheckedBox />
                ) : (
                    ''
                )}
            </Span>

            {iconPlacement === 'start' ? icon : null}

            {label ? (
                <Span className={`CheckboxLabel ${classes?.label ? classes.label : ''}`}>
                    {label}
                </Span>
            ) : null}

            {iconPlacement === 'end' ? icon : null}
        </label>
    );
};

Checkbox.propTypes = {
    unCheckIcon: PropTypes.element,
    unCheckColor: PropTypes.string,
    checkIcon: PropTypes.element,
    checkColor: PropTypes.string,
    classes: PropTypes.object,
    label: PropTypes.node,
    value: PropTypes.string,
    onChange: PropTypes.func,
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
    id: PropTypes.number,
    inputRef: PropTypes.object,
    fullWidth: PropTypes.bool,
    name: PropTypes.string,
    dataFieldId: PropTypes.string,
    style: PropTypes.object,
    checkboxStyle: PropTypes.object,
    icon: PropTypes.element,
    iconPlacement: PropTypes.string,
};

export default React.memo(Checkbox);
